import { useEffect, useState } from 'react';

import { useAuthContext } from '../Auth/context';
import {
  getBooking as fetchBooking,
  getCountries,
  updateBooking as update,
  payBooking as pay
} from './api';

const useAPI = () => {
  const [countries, setCountries] = useState([]);
  const { state: { jwt } } = useAuthContext();

  const getBooking = async (bookingId) => {
    try {
      const { data } = await fetchBooking(bookingId);

      if (data && data.booking) return data?.booking;
      else throw new Error('BOOKING_FAILED');
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    getCountries()
      .then(({ data }) => setCountries(data.countries));
  }, []);

  const updateBooking = (payload) => update(payload, { jwt });
  const payBooking = (bookingId, payLater) => pay(bookingId, payLater, { jwt });

  return {
    actions: { getBooking, updateBooking, payBooking },
    data: { countries }
  };
};

export default useAPI;
